import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../UIElements/Button";
import { Icon } from "../../UIElements/Icon";
import "../states.css";

const EmptyBusinessState = ({ onRetry, isLoading }) => {
  const navigate = useNavigate();

  const handleCreateBusiness = () => {
    navigate("/menu/stores/create/address");
  };

  return (
    <section
      aria-labelledby="empty-business-title"
      className="ui-state-surface flex min-h-[400px] items-center justify-center"
    >
      <div className="mx-auto max-w-md p-6 text-center">
        <div className="ui-state-icon-surface mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-[var(--od-radius-panel)]">
          <Icon name="Building" className="ui-state-muted h-8 w-8" />
        </div>

        <h3 id="empty-business-title" className="mb-2 text-lg font-semibold">
          No Businesses Found
        </h3>

        <p className="ui-state-muted mb-6">
          To get started with the dashboard, you need to create your first
          business. Click the button below to begin.
        </p>

        <div className="space-y-3">
          <Button
            type="button"
            emphasis="solid"
            intent="brand"
            size="touch"
            onClick={handleCreateBusiness}
            className="w-full"
          >
            <Icon name="Plus" className="h-4 w-4" />
            <span>Create My First Business</span>
          </Button>

          <Button
            type="button"
            emphasis="outline"
            intent="neutral"
            size="touch"
            onClick={onRetry}
            disabled={isLoading}
            aria-busy={isLoading || undefined}
            className="w-full"
          >
            {isLoading ? (
              <div className="flex items-center justify-center space-x-2">
                <div
                  aria-hidden="true"
                  className="ui-state-spinner ui-state-motion h-4 w-4 animate-spin rounded-full border-2"
                ></div>
                <span>Refreshing...</span>
              </div>
            ) : (
              "Refresh Page"
            )}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default EmptyBusinessState;
